module.exports = __webpack_public_path__ + "img/0Q3A4704_L_Wood_MockedUp.5755f67d.jpg";